import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useCapacityCache = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const clearAllCapacityCache = async () => {
    try {
      const response = await sendRequest({
        url: '/api/v1/internalBooking/clearAllCache',
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  const clearDocumentCache = async () => {
    try {
      const response = await sendRequest({
        url: '/api/v1/internalBooking/clearDocumentCache',
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  const clearDayCapacityCache = async ({ entertainmentId, date, rebuildCache = true }) => {
    try {
      const response = await sendRequest({
        url: '/api/v1/internalBooking/clearDayCache',
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
        body: {
          entertainmentId,
          date,
          rebuildCache,
        },
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  const clearEntertainmentCapacityCache = async ({ entertainmentId }) => {
    try {
      const response = await sendRequest({
        url: '/api/v1/internalBooking/clearEntertainmentCache',
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
        body: {
          entertainmentId,
        },
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  const regenerateCapacityCache = async ({
    entertainmentId,
    startDate,
    endDate,
    rebuildCache = true,
  }) => {
    try {
      const response = await sendRequest({
        url: '/api/v1/internalBooking/regenerateCache',
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
        body: {
          entertainmentId,
          startDate,
          endDate,
          rebuildCache,
        },
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  const getDayCapacityCache = async ({ entertainmentId, date }) => {
    try {
      const response = await sendRequest({
        url: '/api/v1/internalBooking/cache/by-day',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
        params: {
          entertainmentId,
          date,
        },
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  return {
    isLoading,
    error,
    clearAllCapacityCache,
    clearDocumentCache,
    clearDayCapacityCache,
    clearEntertainmentCapacityCache,
    regenerateCapacityCache,
    getDayCapacityCache,
  };
};

export default useCapacityCache;

